<template>
    <section
        id="packages"
        class="packages-section"
    >
        <div class="container">

            <div class="packages-header">

                <span class="packages-header__eyebrow">
                    {{ 'home_packages' | staticContentAlt }}
                </span>

                <h2>
                    {{ 'home_packages' | staticTitle }}
                </h2>

                <vue-marked>
                    {{ 'home_packages' | staticContent }}
                </vue-marked>

            </div>

            <div class="packages-grid">

                <article class="package-card"  v-for="(packageItem, index) in packages" 
                    :key="packageItem.hash"
                    :class="{ 'package-card--featured': packageItem.featured }" >

                    <div class="package-card__top">

                        <span class="package-card__number">
                            0{{ index + 1 }}
                        </span>

                        <span v-if="packageItem.featured" class="package-card__badge" >
                            {{ 'home_packages_actions' | staticTitle }}
                        </span>

                    </div>

                    <div class="package-card__content">

                        <span class="package-card__type">
                            {{ 'home_packages_labels' | staticTitle }}
                        </span>

                        <h3 class="package-card__title">
                            {{ packageItem.hash | staticTitle }}
                        </h3>

                        <!--
                            <div
                                class="package-card__body"
                                v-html="$options.filters.staticContent(packageItem.hash)"
                            ></div>
                        -->
                            <div class="package-card__body">
                                <vue-marked>
                                    {{ packageItem.hash | staticContent }}
                                </vue-marked>
                            </div>

                    </div>

                    <div class="package-card__pricing">

                        <span class="package-card__price-label">
                            {{ 'home_packages_labels' | staticContent }}
                        </span>

                        <div class="package-card__price">

                            <span class="package-card__price-value">
                                {{ packageItem.hash | staticContentAlt }}
                            </span>

                            <span class="package-card__currency">
                                {{ 'home_packages_labels' | staticContentAlt }}
                            </span>

                        </div>

                    </div>

                    <a
                        href="#contact"
                        class="package-card__cta"
                    >
                        <span>
                            {{ 'home_packages_actions' | staticContent }}
                        </span>

                        <span class="package-card__arrow">
                            ↗
                        </span>
                    </a>

                </article>

            </div>

            <div class="packages-custom">

                <div class="packages-custom__content">

                    <span class="packages-custom__label">
                        {{ 'home_package_custom_labels' | staticTitle }}
                    </span>

                    <h3>
                        {{ 'home_package_custom' | staticTitle }}
                    </h3>

                    <div
                        class="packages-custom__text"
                        v-html="$options.filters.staticContent('home_package_custom')"
                    ></div>

                </div>

                <a
                    href="#contact"
                    class="packages-custom__cta"
                >
                    <span>
                        {{ 'home_package_custom_labels' | staticContent }}
                    </span>

                    <span>
                        ↗
                    </span>
                </a>

            </div>

        </div>
    </section>
</template>

<script>
export default {
    name: 'HomePackages',

    data() {
        return {
            packages: [
                {
                    hash: 'home_package_presence',
                    featured: false
                },
                {
                    hash: 'home_package_professional',
                    featured: true
                },
                {
                    hash: 'home_package_business',
                    featured: false
                }
            ]
        };
    }
};
</script>

<style lang="scss" scoped>
.packages-section {
    position: relative;

    width: 100%;

    padding: 6.25em 1.25em;

    background:
        radial-gradient(
            circle at 85% 15%,
            rgba(233, 81, 29, .05),
            transparent 30%
        ),
        var(--color-1);

    overflow: hidden;
}

.container {
    width: 100%;
    max-width: var(--container);

    margin: 0 auto;
}

.packages-header {
    max-width: 47.5em;

    margin-bottom: 3.4375em;

    &__eyebrow {
        display: flex;
        align-items: center;

        gap: 0.875em;

        margin-bottom: 1.25em;

        color: var(--text-3);

        font-family: var(--font-tech);
        font-size: 0.75em;
        -letter-spacing: 0.1875em;

        text-transform: uppercase;

        &::before {
            content: "";

            width: 2.125em;
            height: 0.0625em;

            background: var(--color-3);
        }
    }

    h2 {
        margin: 0;

        color: var(--text-1);

        font-size: clamp(2.625em, 9vw, 5.125em);
        font-weight: 700;
        line-height: .92;
        -letter-spacing: -0.1875em;

        text-transform: uppercase;
    }

    p {
        max-width: 32.5em;

        margin: 1.5em 0 0;

        color: var(--text-2);

        font-size: 0.875em;
        line-height: 1.7;
    }
}

.packages-grid {
    display: grid;
    grid-template-columns: 1fr;

    width: 100%;

    border-top: 0.0625em solid var(--border-1);
    border-left: 0.0625em solid var(--border-1);
}

.package-card {
    position: relative;

    display: flex;
    flex-direction: column;

    width: 100%;
    min-width: 0;

    padding: 1.75em 1.375em;

    border-right: 0.0625em solid var(--border-1);
    border-bottom: 0.0625em solid var(--border-1);

    background: transparent;

    transition:
        background .35s ease,
        border-color .35s ease,
        transform .35s ease;

    &--featured {
        background:
            linear-gradient(
                180deg,
                rgba(233, 81, 29, .05),
                transparent 36%
            );

        &::before {
            content: "";

            position: absolute;

            top: 0;
            left: 0;
            right: 0;

            height: 0.125em;

            background: var(--color-3);
        }
    }

    &__top {
        display: flex;
        align-items: center;
        justify-content: space-between;

        gap: 1.25em;

        min-height: 1.75em;

        margin-bottom: 2.625em;
    }

    &__number {
        color: var(--text-2);

        font-family: var(--font-tech);
        font-size: .72rem;
        -letter-spacing: 0.09375em;
    }

    &__badge {
        display: inline-flex;
        align-items: center;
        justify-content: center;

        padding: 0.375em 0.625em;

        border: 0.0625em solid var(--border-2);

        color: var(--text-3);

        font-family: var(--font-tech);
        font-size: .62rem;
        -letter-spacing: 0.075em;
    }

    &__content {
        margin-bottom: 1.875em;
    }

    &__type {
        display: block;

        margin-bottom: 0.75em;

        color: var(--text-3);

        font-family: var(--font-tech);
        font-size: .68rem;
        -letter-spacing: 0.1125em;
    }

    &__title {
        margin: 0 0 1.125em;

        color: var(--text-1);

        font-size: clamp(2rem, 8vw, 3rem);
        font-weight: 700;
        line-height: .95;
        -letter-spacing: -0.125em;

        text-transform: uppercase;
    }

    &__body {
        color: var(--text-2);

        font-size: .88rem;
        line-height: 1.7;

        ::v-deep p {
            margin: 0 0 1.375em;
        }

        ::v-deep ul {
            margin: 0;
            padding: 0;

            list-style: none;

            border-top: 0.0625em solid var(--border-1);
        }

        ::v-deep li {
            position: relative;

            min-height: 2.75em;

            padding:
                0.625em 0
                0.625em 1.5em;

            border-bottom:
                0.0625em solid
                var(--border-1);

            color: var(--text-2);

            font-family: var(--font-tech);
            font-size: .66rem;
            line-height: 1.4;
            -letter-spacing: 0.0375em;

            text-transform: uppercase;
        }

        ::v-deep li::before {
            content: "+";

            position: absolute;

            top: 0.625em;
            left: 0;

            color: var(--text-3);
        }
    }

    &__pricing {
        margin-top: auto;
        margin-bottom: 1.5625em;
    }

    &__price-label {
        display: block;

        margin-bottom: 0.5em;

        color: var(--text-2);

        font-family: var(--font-tech);
        font-size: .62rem;
        -letter-spacing: 0.09375em;
    }

    &__price {
        display: flex;
        align-items: flex-end;
        flex-wrap: wrap;

        gap: 0.5em;
    }

    &__price-value {
        color: var(--text-1);

        font-size: clamp(1.45rem, 6vw, 2.15rem);
        font-weight: 700;
        line-height: 1;
        -letter-spacing: -0.0625em;
    }

    &__currency {
        padding-bottom: 0.125em;

        color: var(--text-2);

        font-family: var(--font-tech);
        font-size: .62rem;
        -letter-spacing: 0.0625em;
    }

    &__cta {
        display: flex;
        align-items: center;
        justify-content: space-between;

        gap: 1.25em;

        width: 100%;

        padding-top: 1.125em;

        border-top: 0.0625em solid var(--border-1);

        color: var(--text-1);

        font-family: var(--font-tech);
        font-size: .68rem;
        -letter-spacing: 0.075em;

        transition: color .3s ease;
    }

    &__arrow {
        flex-shrink: 0;

        color: var(--text-3);

        font-size: 1rem;

        transition: transform .3s ease;
    }
}

.packages-custom {
    display: flex;
    flex-direction: column;

    gap: 1.875em;

    margin-top: 2.5em;

    padding: 2.1875em 0;

    border-top: 0.0625em solid var(--border-1);
    border-bottom: 0.0625em solid var(--border-1);

    &__content {
        max-width: 40.625em;

        h3 {
            margin: 0 0 1em;

            color: var(--text-1);

            font-size: clamp(2rem, 7vw, 4.2rem);
            font-weight: 700;
            line-height: .95;
            -letter-spacing: -0.125em;

            text-transform: uppercase;
        }
    }

    &__label {
        display: block;

        margin-bottom: 0.875em;

        color: var(--text-3);

        font-family: var(--font-tech);
        font-size: .68rem;
        -letter-spacing: 0.09375em;
    }

    &__text {
        color: var(--text-2);

        font-size: .9rem;
        line-height: 1.7;

        ::v-deep p {
            margin: 0 0 1.125em;
        }

        ::v-deep ul {
            margin: 0;
            padding: 0;

            display: grid;
            grid-template-columns: 1fr;

            gap: 0.5em;

            list-style: none;
        }

        ::v-deep li {
            position: relative;

            padding-left: 1.25em;

            color: var(--text-2);

            font-family: var(--font-tech);
            font-size: .68rem;
            line-height: 1.5;

            text-transform: uppercase;
        }

        ::v-deep li::before {
            content: "+";

            position: absolute;

            left: 0;

            color: var(--text-3);
        }
    }

    &__cta {
        display: flex;
        align-items: center;
        justify-content: space-between;

        gap: 1.875em;

        width: 100%;

        padding: 1.125em 1.375em;

        border: 0.0625em solid var(--border-2);

        color: var(--text-1);

        font-family: var(--font-tech);
        font-size: .72rem;
        -letter-spacing: 0.08125em;

        transition:
            color .3s ease,
            background .3s ease,
            transform .3s ease;

        &:hover {
            background:
                rgba(233, 81, 29, .10);

            transform: translateY(-0.1875em);
        }
    }
}

@media (hover: hover) and (pointer: fine) {
    .package-card {
        &:hover {
            background:
                rgba(255, 255, 255, .018);
        }

        &:hover .package-card__cta {
            color: var(--text-3);
        }

        &:hover .package-card__arrow {
            transform:
                translate(0.25em, -0.25em);
        }
    }
}

@media (min-width: 48em) {
    .packages-section {
        padding: 6.875em 2.5em;
    }

    .packages-header {
        margin-bottom: 4.0625em;
    }

    .packages-grid {
        grid-template-columns:
            repeat(2, minmax(0, 1fr));
    }

    .package-card {
        padding: 2em 1.75em;
    }

    .packages-custom {
        flex-direction: row;
        align-items: flex-end;
        justify-content: space-between;

        gap: 3.125em;

        padding: 2.5em 0;

        &__text {
            ::v-deep ul {
                grid-template-columns:
                    repeat(2, 1fr);
            }
        }

        &__cta {
            width: auto;
            min-width: 14.375em;
        }
    }
}

@media (min-width: 64em) {
    .packages-section {
        padding: 7.8125em 3.125em;
    }

    .packages-grid {
        grid-template-columns:
            repeat(3, minmax(0, 1fr));
    }

    .package-card {
        padding: 2.125em 1.875em;

        &__top {
            margin-bottom: 3.25em;
        }
    }
}

@media (min-width: 87.5em) {
    .packages-section {
        padding-left: 4.375em;
        padding-right: 4.375em;
    }

    .package-card {
        padding: 2.375em 2.125em;
    }
}
</style>